import React from "react";
var __jsx = React.createElement;
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "@i18n";
import DialogSelect from "@/components/DialogSelect/DialogSelect";
export function RHFDialogSelect(_ref) {
  var name = _ref.name,
    options = _ref.options,
    searchFunction = _ref.searchFunction,
    getDisplayName = _ref.getDisplayName,
    label = _ref.label,
    placeholder = _ref.placeholder,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    searchPlaceholder = _ref.searchPlaceholder,
    dialogTitle = _ref.dialogTitle,
    _ref$allowClear = _ref.allowClear,
    allowClear = _ref$allowClear === void 0 ? true : _ref$allowClear,
    renderOption = _ref.renderOption,
    _ref$debounceDelay = _ref.debounceDelay,
    debounceDelay = _ref$debounceDelay === void 0 ? 300 : _ref$debounceDelay,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 50 : _ref$limit,
    id = _ref.id;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
        onChange = _ref2$field.onChange,
        value = _ref2$field.value,
        error = _ref2.fieldState.error;
      return /*#__PURE__*/React.createElement(DialogSelect, {
        value: value,
        onChange: onChange,
        options: options,
        searchFunction: searchFunction,
        getDisplayName: getDisplayName,
        placeholder: placeholder,
        disabled: disabled,
        error: error ? tShort(error.message, {
          ns: "validations"
        }) : undefined,
        label: label,
        className: className,
        searchPlaceholder: searchPlaceholder,
        dialogTitle: dialogTitle,
        allowClear: allowClear,
        renderOption: renderOption,
        debounceDelay: debounceDelay,
        limit: limit,
        id: id
      });
    }
  });
}
export default RHFDialogSelect;